<div class="modal-header">
  <h4 class="modal-title">Importer un document drive</h4>
  <button (click)="onCloseModal()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<div class="modal-body">
  <div class="row">
    <form #ngForm="ngForm" [formGroup]="form" id="form">
      <div class="col-12 col-lg-12 mb-3">
        <label>Nom document</label>
        <input
          type="text"
          class="form-control"
          name="fileName"
          formControlName="fileName"
          [class.is-invalid]="form.get('fileName').invalid && ngForm.submitted"
          />
          <div class="invalid-feedback d-block">
            @if (this.form.get('fileName').invalid && ngForm.submitted) {
              <div>
                Le nom du document est obligatoire
              </div>
            }
          </div>
        </div>
        <div class="col-12 col-lg-12 mb-3">
          <label>Lien drive</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="lienDocumentDrive"
              formControlName="lienDocumentDrive"
              [class.is-invalid]="form.get('lienDocumentDrive').invalid && ngForm.submitted"
              />
              <span class="input-group-text">
                <img
                  [ngSrc]="drivePickerOnModal"
                  alt="drivePickerIcon"
                  width="24"
                  height="24"
                  role="button"
                  (click)="openDrivePicker()"
                  />
                </span>
              </div>
              <div class="invalid-feedback d-block">
                @if (form.get('lienDocumentDrive').hasError('required') && ngForm.submitted) {
                  <div>
                    Le lien du drive est obligatoire
                  </div>
                }
                @if (form.get('lienDocumentDrive').hasError('invalidGoogleDriveLink') && ngForm.submitted) {
                  <div>
                    Le lien du drive est invalide.
                  </div>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <div class="container w-100">
          <div class="row gx-5 gy-3">
            <div class="col-12 col-lg-12 text-end">
              <button (click)="onSubmit()" type="submit" form="form" class="btn btn-primary w-50">
                Valider
              </button>
            </div>
          </div>
        </div>
      </div>
